import { useWizardMaster } from '@components/OrderWizard/Contexts/WizardMasterContext'
import { addCommasToNumber, GraviButton, Horizontal, Texto } from '@gravitate-js/excalibrr'
import type React from 'react'
import { CalendarOutlined, InfoCircleFilled } from '@ant-design/icons'
import orderRequestIcon from '@assets/CustomIcons/order-request-icon-gradient.svg'
import moment from 'moment'
import { formatters } from '@utils/intl/dateTimeFormatters'
import { OrderRequestPopover } from '@components/_SiteWide/OrderRequestPopover'

export const OriginalRequest: React.FC = () => {
  const { wizardOrder } = useWizardMaster()
  const requestItem = wizardOrder.order_request_info
  if (!requestItem) return null
  const sameDays = moment(requestItem.delivery_window_start).isSame(requestItem.delivery_window_end, 'day')
  const dates = sameDays
    ? `${formatters.MONTH_DATE_YEAR_TIME(requestItem.delivery_window_start)} - ${formatters.TIME(
        requestItem.delivery_window_end
      )}`
    : `${formatters.MONTH_DATE_YEAR_TIME(requestItem.delivery_window_start)} - ${formatters.MONTH_DATE_YEAR_TIME(
        requestItem.delivery_window_end
      )}`

  return (
    <>
      <Horizontal verticalCenter className={'p-3'} style={{ background: 'var(--theme-color-2-dim)' }}>
        <Texto textTransform={'uppercase'}>Order Request</Texto>
      </Horizontal>
      <Horizontal verticalCenter className={'p-2'} justifyContent={'space-between'}>
        <Horizontal className={'full-height-width'}>
          <img src={orderRequestIcon} alt={'order request icon'} style={{ width: '17px' }} className={'mr-2'} />
          <Texto className={'text-truncate'}>{requestItem?.customer_name}</Texto>
        </Horizontal>
        <Horizontal justifyContent={'end'} verticalCenter className={'full-height-width mr-2'}>
          <CalendarOutlined className={'mr-1'} />
          <Texto className={'text-truncate'}>{dates}</Texto>
        </Horizontal>
        <Horizontal verticalCenter justifyContent={'end'} className={'full-height-width'}>
          <Texto weight={'bold'} className={'mr-1 text-truncate'}>
            Total Request Volume
          </Texto>
          <Texto>{addCommasToNumber(requestItem.total_volume, 0)}</Texto>
          <OrderRequestPopover
            requestItem={requestItem}
            origins={wizardOrder.origins}
            acceptBy={wizardOrder.accept_by}
            hoverElement={
              <GraviButton
                className={'ghost-gravi-button m-0 p-0'}
                icon={<InfoCircleFilled style={{ color: 'var(--theme-color-1)' }} />}
              />
            }
          />
        </Horizontal>
      </Horizontal>
    </>
  )
}
